'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const getNextDay = (date) => {
    const nextDay = new Date(date);
    nextDay.setDate(date.getDate() + 1);
    return nextDay;
};

exports.getNextDay = getNextDay;
//# sourceMappingURL=get-next-day.js.map
